import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value?: number | string | null): string {
  if (!value) return 'R$ 0,00';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(numValue);
}

/** Data e hora pt-BR de um ISO da API; `empty` quando não há valor. */
export function formatDateTime(value: string | null | undefined, empty = '-'): string {
  return value ? new Date(value).toLocaleString('pt-BR') : empty;
}

/**
 * Formata uma data que vem da API (ISO ou YYYY-MM-DD) como DD/MM/YYYY
 * usando apenas a parte da data, sem conversão UTC (evita voltar um dia).
 */
export function formatDateOnly(value: string | null | undefined): string {
  if (value == null || value === '') return '';
  const s = String(value).slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-');
    return `${d}/${m}/${y}`;
  }
  try {
    const [y, m, d] = s.split('-');
    if (d && m && y) return `${d}/${m}/${y}`;
  } catch {
    // fallback
  }
  return value;
}

